import { Box, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { useIsMobile, useL10n } from '@uplift/hooks';
import { VolunteerActivismIcon } from '@uplift/icons';
import { Alert } from '@uplift/ui-v2';

export const InReviewStepSection: React.VFC = () => {
  const isMobile = useIsMobile();
  const l10n = useL10n();
  const { classes } = useStyles();

  return (
    <Box display="flex" flexDirection="column" justifyContent="center" m={!isMobile && -6} >
      <Alert severity="success" flat className={classes.alert}>
        <Typography variant="body1">
          {l10n.providerSettings.onboarding.allToDosDone}
        </Typography>
      </Alert>
      <Box display="flex" flexDirection="column" justifyContent="center" p={!isMobile && 6}>
        <Box display="flex" flexDirection="column" mb={3} mt={isMobile ? 5 : 10} ml={isMobile ? 2 : 0} gap="16px">
          <VolunteerActivismIcon className={classes.icon}/>
          <Typography variant="h3" className={classes.blue}>
            {l10n.providerSettings.onboarding.didYouKnowTitle}
          </Typography>
          <Typography variant="h4">
            {l10n.providerSettings.onboarding.didYouKnowMessages[0]}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

const useStyles = makeStyles()(theme => ({
  blue: {
    color: theme.palette.info.main,
  },
  icon: {
    color: theme.palette.info.main,
    fontSize: '2.5rem',
    [theme.breakpoints.up('md')]: {
      fontSize: '4rem'
    },
  },
  alert: {
    fontWeight: 450,
    display: 'flex',
    justifyContent: 'center',
  }
}));
